<template>
    <div class="bank-details">
        <CaseDocuments :show_documents.sync="modals.show_documents" ref="bankDocuments" :bank="document_bank" :product="product" :customer_id="product.prod_customer_id"/>
        <CasesEditBankModal :show_edit_bank.sync="modals.show_edit_bank" :bank="edit_bank" :product="product" v-if="product.product_banks.length > 0"/>
        <CasesEditCashBuyerModal :show_edit_cash_buyer.sync="modals.show_edit_cash_buyer" :bank="edit_bank" :product="product" v-if="product.product_banks.length > 0"/>

          <div class="card-table rounded-bottom">
            <el-table
            :data="tableData"
            style="width: 100%">
                <el-table-column
                    label="PIC/Bank"
                    min-width="100"
                    >
                    <template slot="header">
                        <div class="d-block">
                            <span class="main-column-label">Bank</span><br>
                            <span class="sub-column-label">/Banker</span>
                        </div>
                    </template>
                    <template slot-scope="scope">
                      <template v-if="scope.row.prod_bnk_code === 'CASH_BUYER'">
                          <p class="bottom-line">{{ scope.row.prod_bnk_name }}</p>
                      </template>
                      <template v-else>
                          <el-image
                              class="rounded mr-2"
                              :src="scope.row.prod_bnk_logo_url"
                              fit="cover"
                              style="height: 15px;"
                          ></el-image>
                          <p class="bottom-line" v-if="scope.row.prod_bnk_banker_detail">{{ scope.row.prod_bnk_banker_detail.name }}</p>
                          <p class="bottom-line" v-else>N/A</p>
                      </template>
                  </template>
                </el-table-column>
                <el-table-column
                    label="Stage/Status"
                    min-width="120"
                    >
                    <template slot="header">
                        <div class="d-block">
                            <span class="sub-column-label">Status</span>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <b-badge pill class="text-white font-weight-500 bg-primary">{{ scope.row.prod_bnk_stage_status_label }}</b-badge>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Loan Amount/Interest/Margin/Tenure"
                    min-width="160"
                    >
                    <template slot="header">
                        <div class="d-block">
                            <span class="main-column-label">Loan Amount</span><br>
                            <span class="sub-column-label">/Interest/Margin/Tenure</span>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM{{ scope.row.prod_bnk_loan_amount | moneyFormatter }}</p>
                        <p class="bottom-line" v-if="scope.row.prod_bnk_code !== 'CASH_BUYER'">
                            {{ scope.row.prod_bnk_interest }} | {{ scope.row.prod_bnk_margin }} | {{ scope.row.prod_bnk_tenure }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Instalment"
                    min-width="120"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM{{ scope.row.prod_bnk_installment | moneyFormatter }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    width="70"
                    class-name="icons-chat"
                >
                    <template slot-scope="scope">
                        <MessagingBoxButton :type="'banker'" :profile="scope.row" />
                    </template>
                </el-table-column>
                <el-table-column min-width="90">
                    <template slot-scope="scope">
                        <div class="d-flex">
                            <el-button class="px-0" type="text" @click="editBankHandler(scope.row)" :disabled="isTerminalBankStatus(scope.row)">
                                <b-icon icon="pencil-square" class="mr-2"></b-icon>
                            </el-button>
                            <el-button class="px-0" @click="showBankDocumentHandler(scope.row)" type="text" v-b-tooltip.hover="'Documents'">
                                <b-icon icon="file-earmark-fill" class="text-success mr-2"></b-icon>
                            </el-button>
                            <el-button class="px-0" type="text" 
                                v-b-tooltip.hover="'Remove'" 
                                @click="removeBankHandler(scope.row)"
                                v-if="!scope.row.prod_bnk_submission_date"
                            >
                                <b-icon icon="x-circle-fill" class="text-danger"></b-icon>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Button,Image } from 'element-ui'
import CaseDocuments from '@/views/CustomerProfile/CustomerModals/CasesDocumentsModal'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { notifyFunctionMixin } from '@/assets/js/httpImports.js'
import CasesEditBankModal from '@/views/CustomerProfile/CustomerModals/CasesEditBankModal'
import CasesEditCashBuyerModal from '@/views/CustomerProfile/CustomerModals/CasesEditCashBuyerModal'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
    props: ['product'],
    mixins: [notifyFunctionMixin],
    components: {
        CasesEditBankModal,
        CasesEditCashBuyerModal,
        CaseDocuments,
        MessagingBoxButton,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        [Image.name]: Image,
    },
    data() {
        return {
            tableData: [],
            modals: {
                show_documents: false,
                show_edit_bank: false,
                show_edit_cash_buyer: false 
            },
            edit_bank: null,
            document_bank: null,
            current_bank_id:null
        }
    },
    watch:{
        'product.product_banks':{
            handler(newVal){
                const banks = Array.isArray(newVal) ? newVal : []
                this.tableData = banks
                this.edit_bank = banks[0]
                this.document_bank = banks[0]
                this.getProfileListMessagesSummaries('banker',this.tableData);
            },
            immediate: true
        }
    },
    methods:{
        ...mapActions(useProductStore, ['removePropertyProductBank']),
        ...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),

        async removeBankHandler(bank){
            let message = 'Are you sure you want to remove the bank?'
            if(confirm(message) == true){
                try{
                    await this.removePropertyProductBank(bank)
                    caseEventBus.$emit('refresh-cases')
                    this.notifySuccess('<b>Bank</b> - Successfully Removed.')
                }catch(e){
                    this.errorFunction(e)
                }
            }
        },
        isTerminalBankStatus(bank){
            const terminals = ['Rejected','Rejected by Bank','Declined by client','Declined by Client','Cancelled','Cancel Application'].map(s=>s.toLowerCase())
            const vals = [ _gHlp.getValue(bank,'prod_bnk_stage_status'), _gHlp.getValue(bank,'prod_bnk_stage_status_label') ]
            return vals.some(v=> terminals.includes(String(v||'').trim().toLowerCase()))
        },
        editBankHandler(bank) {
            this.edit_bank = bank
            if (bank.prod_bnk_code === 'CASH_BUYER') {
                this.modals.show_edit_cash_buyer = true
            } else {
                this.modals.show_edit_bank = true
            }
        },
        showBankDocumentHandler(bank){
            this.document_bank = bank
            this.$refs.bankDocuments.getCustomerAttachments()
            this.$refs.bankDocuments.getBankAttachments(bank.prod_bnk_id)
            this.modals.show_documents = true
        }
    }
}
</script>
